import { useState, useEffect } from "react";

import apiCall from "../../helperFunctions/apiCall";
import { getAssessmentByGroup } from "../utilities/auth/authAPI";

import { Loading } from "../utilities/helpers";
import AssessGroup from "./assessGroup";


function AssessGroups(props) {

  // Define variables
  const [groups, setGroups] = useState(null);
  const organizationId = props.organizationId;
  const viewCode = props.viewCode;


  // Component load actions
  useEffect(() => {
    apiCall(getAssessmentByGroup, {id: organizationId}).then((response) => {
      if( response.success ) {
        setGroups(response.data);
      } else {
        alert('Sorry, there was an error. Please contact support@flowspeak.io');
      }
    });
  }, []);


  // Screen components
  let bodyElement;
  if( groups ) {
    bodyElement = (
      <div style={{marginTop: '30px'}}>
        {groups.map((group, index) =>
          <AssessGroup key={`assessment-group-month-${index}`} group={group} viewCode={viewCode} />
        )}
      </div>
    );
  } else {
    bodyElement = (
      <div class='flex-column' style={{marginTop: '120px'}}>
        <Loading />
      </div>
    );
  }


  return (
    <div style={{width: '100%'}}>
      <p>View each Groups's Assessments over time</p>
      {bodyElement}
    </div>
  );
}

export default AssessGroups;